import axios from "axios";
import store from "@/store";

// 設定ファイル取得
export async function setTrackingEventDataSetting() {
  try {
    let result = await fetchTrackingEventDataSetting();
    store.dispatch("setTrackingEventDataSetting", result);
    // eslint-disable-next-line no-empty
  } catch (error) {}
}

function fetchTrackingEventDataSetting() {
  return new Promise(function (resolve, reject) {
    const url = process.env.VUE_APP_TRACKING_EVENT_DATA_SETTING;
    axios
      .get(url, { headers: { "Content-Type": "application/json" } })
      .then((res) => {
        let result = res.data;
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

// デバイス情報取得
export async function getDeviceInfoData() {
  let deviceInfoData = {
    system_auid: store.getters.getSystemAuId,
    ClientTimeZone: getClientTimeZone(),
    DisplaySize: getDisplaySize(),
    Browser: getBrowser(),
    Language: getLanguage(),
    Os: getOs(),
    JavaFlag: getJavaFlag(),
    Referrer: getReferrer(),
    LineType: getLineType(),
    Ip: await getIpAddress(),
  };
  return deviceInfoData;
}

async function getIpAddress() {
  try {
    let ipAddress = await fetchIpAddress();
    return ipAddress || "";
  } catch (error) {
    return "";
  }
}

function getClientTimeZone() {
  try {
    const moment = require("moment");
    return moment().format("ZZ") || "";
  } catch (error) {
    return "";
  }
}

function getDisplaySize() {
  try {
    return `${window.parent.screen.width}x${window.parent.screen.height}` || "";
  } catch (error) {
    return "";
  }
}

function getBrowser() {
  try {
    const uaParser = require("ua-parser-js");
    const name = uaParser().browser.name || "";
    const version = uaParser().browser.version || "";
    return `${name} ${version}`;
  } catch (error) {
    return "";
  }
}

function getLanguage() {
  try {
    return window.navigator.language || "";
  } catch (error) {
    return "";
  }
}

function getOs() {
  try {
    const uaParser = require("ua-parser-js");
    const name = uaParser().os.name || "";
    const version = uaParser().os.version || "";
    return `${name} ${version}`;
  } catch (error) {
    return "";
  }
}

function getJavaFlag() {
  try {
    return window.navigator.javaEnabled() ? "true" : "false";
  } catch (error) {
    return "";
  }
}

function getReferrer() {
  try {
    return document.referrer || "";
  } catch (error) {
    return "";
  }
}

function getLineType() {
  try {
    return window.navigator.connection.type || "";
  } catch (error) {
    return "";
  }
}

function fetchIpAddress() {
  return new Promise(function (resolve, reject) {
    let xhr = new XMLHttpRequest();
    xhr.open("GET", "/");
    xhr.send();
    xhr.onload = () => {
      let clientIp = xhr.getResponseHeader("client-ip");
      resolve(clientIp);
    };
    xhr.onerror = () => {
      reject(xhr.status);
    };
  });
}
